import React, { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Box from "@mui/material/Box";
import { Grid } from "@mui/material";
import Button from "@mui/material/Button";
import { ErrorModal } from "@soqs/common";
import { ConfirmDangerModalComponent } from "@soqs/common";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import OTPMultiEntryComponent from "./OTPMultiEntryComponent";
import {
  errors,
  isLoading,
  submitOTPAsync,
  clearErrors,
  selectedOTPMethod,
  cancelVerification,
  timeout,
} from "../features/AppSlice";
import { useDispatch, useSelector } from "react-redux";

const OTPVerificationComponent = () => {
  const dispatch = useDispatch();
  const loading = useSelector(isLoading);
  const errorState = useSelector(errors);
  const selectedMethod = useSelector(selectedOTPMethod);

  let cbClear;

  const [confirmBackModalOpen, setconfirmBackModalOpen] = useState(false);
  const [secondsRemaining, setSecondsRemaining] = useState(0);

  useEffect(() => {
    let refreshtimer;
    refreshtimer = setInterval(() => {
      const newSecondsRemaining = Math.floor(
        (new Date(selectedMethod.expiry) - new Date()) / 1000
      );
      if (newSecondsRemaining < 1 && errorState == null) {
        dispatch(timeout());
      } else {
        setSecondsRemaining(newSecondsRemaining);
      }
    }, 1000);
    return () => {
      clearInterval(refreshtimer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (otpFromChild) => {
    await dispatch(submitOTPAsync(otpFromChild));
    cbClear();
  };

  return (
    <>
      <Grid size={{ xs: 12 }}>
        <br />
        <Card>
          <CardContent>
            <Box component="form">
              <Grid
                item
                container
                spacing={2}
                direction="column"
                alignItems="center"
              >
                <Grid padding={2}>
                  <Typography>
                    Please enter the OTP sent to{" "}
                    {selectedMethod.destinationMasked}
                  </Typography>
                </Grid>
                <Grid>
                  <OTPMultiEntryComponent
                    otpHint={selectedMethod.otpHint}
                    cbSubmit={handleSubmit}
                    cbClear={(clearfn) => {
                      cbClear = clearfn;
                    }}
                  />
                </Grid>
                <Grid>
                  {loading || errorState !== null ? null : (
                    <CircularTimer
                      value={secondsRemaining / 1.8}
                      secondsRemaining={secondsRemaining}
                    />
                  )}
                </Grid>
              </Grid>
              <Grid size={{ xs: 12 }}>
                <Grid container justifyContent="space-between">
                  <Grid>
                    <Button
                      type="button"
                      variant="outlined"
                      onClick={() => {
                        setconfirmBackModalOpen(true);
                      }}
                    >
                      Back
                    </Button>
                  </Grid>
                  <Grid>
                    <Button
                      align="right"
                      loading={loading}
                      type="submit"
                      variant="contained"
                      onClick={(evt) => {
                        evt.preventDefault();
                        handleSubmit();
                      }}
                    >
                      Submit
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </CardContent>
        </Card>
        <ConfirmDangerModalComponent
          title="Quit Verification"
          subheader="Are you sure you want to cancel the verification process and restart?"
          confirmText="Cancel verification"
          cancelText="Continue verification"
          open={confirmBackModalOpen}
          onClose={() => setconfirmBackModalOpen(false)}
          cbConfirm={() => dispatch(cancelVerification())}
        />
        <ErrorModal
          title={errorState?.errortitle ?? "Error"}
          open={errorState !== null}
          onClose={() => {
            if (errorState?.fatal) {
              dispatch(cancelVerification());
            } else {
              dispatch(clearErrors());
            }
          }}
          subheader={
            Array.isArray(errorState?.error) ? (
              <ul>
                {errorState?.error.map((e, idx) => (
                  <li key={idx}>{e}</li>
                ))}
              </ul>
            ) : (
              <p>{errorState?.error}</p>
            )
          }
        />
      </Grid>
    </>
    /*       </Grid>
    </Grid> */
  );
};

const CircularTimer = (props) => {
  return (
    <Grid container direction="column" alignItems="center">
      <Grid>
        <Box sx={{ position: "relative", display: "inline-flex" }}>
          <CircularProgress variant="determinate" {...props} />
          <Box
            sx={{
              top: 0,
              left: 0,
              bottom: 0,
              right: 0,
              position: "absolute",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography
              variant="caption"
              component="div"
              color="text.secondary"
            >
              {`${Math.floor(props.secondsRemaining / 60)}:${(
                props.secondsRemaining % 60
              )
                .toString()
                .padStart(2, "0")}`}
            </Typography>
          </Box>
        </Box>
      </Grid>
      <Grid>
        <Typography>Time remaining</Typography>
      </Grid>
    </Grid>
  );
};

export default OTPVerificationComponent;
